import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './../http.service';

@Injectable({
  providedIn: 'root'
})
export class LearningComplexityService {
  constructor(private httpService: HttpService) {}

  getComplexities(): Observable<{ complexities: string[] }> {
    return this.httpService.httpGet('learning/complexities');
  }
}
